import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=0ec746aa&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=0ec746aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec746aa",
  null
  
)

export default component.exports